<template>
  <div class="maintenance-page">
    <div class="m-box">
      <div class="m-icon">
        <svg width="72" height="72" viewBox="0 0 24 24" fill="none">
          <path d="M14.7 6.3a5 5 0 0 0-6.9 6.9L3 18v3h3l4.8-4.8a5 5 0 0 0 6.9-6.9l-2.6 2.6-2.3-.5-.5-2.3 2.4-2.1z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h1 class="m-title">{{ $t('maintenance.title') }}</h1>
      <p class="m-desc">{{ $t('maintenance.desc') }}</p>
      <div class="m-loader">
        <span></span><span></span><span></span>
      </div>
      <p class="m-tip">{{ $t('maintenance.tip') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenancePage'
}
</script>

<style scoped>
.maintenance-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0B4F8C 0%, #1565C0 100%);
  padding: 40px 24px;
}

.m-box {
  text-align: center;
  color: #FFFFFF;
  max-width: 520px;
}

.m-icon {
  color: #FFD54F;
  margin-bottom: 20px;
  animation: mFloat 3s ease-in-out infinite;
}

@keyframes mFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.m-title {
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 16px;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

.m-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.8;
  margin-bottom: 32px;
}

.m-loader {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 28px;
}

.m-loader span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #64B5F6;
  animation: mBounce 1.2s ease-in-out infinite;
}

.m-loader span:nth-child(2) {
  animation-delay: 0.15s;
}

.m-loader span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes mBounce {
  0%, 100% { transform: translateY(0); opacity: 0.6; }
  50% { transform: translateY(-10px); opacity: 1; }
}

.m-tip {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
}

@media (max-width: 480px) {
  .m-title {
    font-size: 28px;
  }
}
</style>
